import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Popconfirm } from 'antd';
import { Button, Space } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';
import { PopconfirmDescription } from 'components';
import { BookingStore } from 'store';

type Props = {
  active: boolean;
  onNext: () => void;
  onBack: () => void;
  isLoading?: boolean;
  hasSlot?: boolean;
} & WithOptionalDataTest;

export const Actions: FC<Props> = observer((props) => {
  const navigate = useNavigate();
  const { active, onNext, onBack, hasSlot, isLoading } = props;
  const { resetBookingProgress } = BookingStore;

  const handleLeaveBooking = () => {
    navigate('/dashboard');
    resetBookingProgress();
  };

  return (
    <Space.$ direction={Space.Direction.Horizontal} size={Space.Size.Small} justify={Space.Justify.End}>
      <Popconfirm
        title="Alert"
        onConfirm={onBack}
        description={<PopconfirmDescription hasSlot={hasSlot} />}
        okText="Yes"
      >
        <div>
          <Button.$ dataTestId="page-back-btn" onClick={() => null} disabled={isLoading}>
            &lt; Back
          </Button.$>
        </div>
      </Popconfirm>

      <Popconfirm
        title="Alert"
        onConfirm={() => {
          handleLeaveBooking();
        }}
        description={<PopconfirmDescription hasSlot={hasSlot} />}
        okText="Yes"
      >
        <div>
          <Button.$ dataTestId="page-cancel-btn" danger onClick={() => null} disabled={isLoading}>
            Cancel this booking
          </Button.$>
        </div>
      </Popconfirm>

      <Button.$
        dataTestId="page-next-btn"
        disabled={!active}
        onClick={onNext}
        loading={isLoading}
        type={Button.Type.Primary}
      >
        Next (Complete customer files & payment method) &gt;
      </Button.$>
    </Space.$>
  );
});
